<div
	[ngClass]="{
		'mt-md-0 text-md-end': contentAlignment === contentAlignmentEnum.AS_ROWS,
		'disabled': requestInProgress || disableDownloadButton
	}"
>

	<button
		@fadeInOut
		*ngIf="buttonLabel && showButton"
		type="button"
		[class]="'btn w-100 ' + ( buttonStyleClass ?? '' )"
		[ngClass]="{
			'position-relative multiFormat-button': isMultiFormatDownloadButton
		}"
		[delayClickOutsideInit]="true"
		(click)="emitButtonEvent()"
		(clickOutside)="updateDownloadButtonCollapsedState( true )"
		(mouseenter)="updateDownloadButtonCollapsedState( false )"
		(mouseleave)="updateDownloadButtonCollapsedState( true )"
		(touchend)="emitButtonEvent()"
		(touchstart)="$event.preventDefault();"
	>

		<!-- Icon, Label -->
		<div class="row gx-2 flex-nowrap justify-content-center align-items-center">

			<!-- Icon -->
			<app-svg
				*ngIf="showIcon"
				class="col-auto ps-0 pe-2 align-text-bottom"
				[type]="iconSvgType"
			></app-svg>

			<!-- Label -->
			<span class="col-auto px-0 text-nowrap">{{ buttonLabel }}</span>
		</div>

		<!-- Format Button -->
		<div
			*ngIf="isMultiFormatDownloadButton"
			class="format-button-wrapper pb-2 px-2 mt-1"
			[ngbCollapse]="multiFormatDownloadButtonIsCollapsed"
		>

			<!-- Format Button Items -->
			<button
				*ngFor="let format of supportedDownloadFormats"
				class="btn col-12 mt-1 cursor-pointer"
				type="button"
				(click)="selectedDownloadFormat = format; emitButtonEvent()"
				(touchend)="selectedDownloadFormat = format; emitButtonEvent()"
			>
				<!-- Label -->
				<span class="align-middle">{{ format | uppercase }}</span>
			</button>
		</div>
	</button>
</div>
